module.exports = __webpack_public_path__ + "officialStatic/img/psq.98c6161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/psq.png
// module id = 1bnH
// module chunks = 0